/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ComponentDefinitionItemsDto } from '../models';
/**
 * RestComponentDefinitionItemsApi - axios parameter creator
 */
export const RestComponentDefinitionItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary update items in package component definition for now only dictionary of type PACKAGE_OFFER_ITEM is supported
         * @param {number} componentDefinitionId 
         * @param {ComponentDefinitionItemsDto} componentDefinitionItemsDto Update items in package component definition request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItemsInPackageComponentDefinition: async (componentDefinitionId: number, componentDefinitionItemsDto: ComponentDefinitionItemsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentDefinitionId' is not null or undefined
            assertParamExists('updateItemsInPackageComponentDefinition', 'componentDefinitionId', componentDefinitionId)
            // verify required parameter 'componentDefinitionItemsDto' is not null or undefined
            assertParamExists('updateItemsInPackageComponentDefinition', 'componentDefinitionItemsDto', componentDefinitionItemsDto)
            const localVarPath = `/api/component-definitions/{componentDefinitionId}/items`
                .replace('{componentDefinitionId}', encodeURIComponent(String(componentDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(componentDefinitionItemsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestComponentDefinitionItemsApi - functional programming interface
 */
export const RestComponentDefinitionItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestComponentDefinitionItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary update items in package component definition for now only dictionary of type PACKAGE_OFFER_ITEM is supported
         * @param {number} componentDefinitionId 
         * @param {ComponentDefinitionItemsDto} componentDefinitionItemsDto Update items in package component definition request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateItemsInPackageComponentDefinition(componentDefinitionId: number, componentDefinitionItemsDto: ComponentDefinitionItemsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateItemsInPackageComponentDefinition(componentDefinitionId, componentDefinitionItemsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestComponentDefinitionItemsApi.updateItemsInPackageComponentDefinition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestComponentDefinitionItemsApi - factory interface
 */
export const RestComponentDefinitionItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestComponentDefinitionItemsApiFp(configuration)
    return {
        /**
         * 
         * @summary update items in package component definition for now only dictionary of type PACKAGE_OFFER_ITEM is supported
         * @param {number} componentDefinitionId 
         * @param {ComponentDefinitionItemsDto} componentDefinitionItemsDto Update items in package component definition request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItemsInPackageComponentDefinition(componentDefinitionId: number, componentDefinitionItemsDto: ComponentDefinitionItemsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateItemsInPackageComponentDefinition(componentDefinitionId, componentDefinitionItemsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestComponentDefinitionItemsApi - interface
 */
export interface RestComponentDefinitionItemsApiInterface {
    /**
     * 
     * @summary update items in package component definition for now only dictionary of type PACKAGE_OFFER_ITEM is supported
     * @param {number} componentDefinitionId 
     * @param {ComponentDefinitionItemsDto} componentDefinitionItemsDto Update items in package component definition request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateItemsInPackageComponentDefinition(componentDefinitionId: number, componentDefinitionItemsDto: ComponentDefinitionItemsDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestComponentDefinitionItemsApi - object-oriented interface
 */
export class RestComponentDefinitionItemsApi extends BaseAPI implements RestComponentDefinitionItemsApiInterface {
    /**
     * 
     * @summary update items in package component definition for now only dictionary of type PACKAGE_OFFER_ITEM is supported
     * @param {number} componentDefinitionId 
     * @param {ComponentDefinitionItemsDto} componentDefinitionItemsDto Update items in package component definition request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateItemsInPackageComponentDefinition(componentDefinitionId: number, componentDefinitionItemsDto: ComponentDefinitionItemsDto, options?: RawAxiosRequestConfig) {
        return RestComponentDefinitionItemsApiFp(this.configuration).updateItemsInPackageComponentDefinition(componentDefinitionId, componentDefinitionItemsDto, options).then((request) => request(this.axios, this.basePath));
    }
}

